import PreferredWorkLocationsPicker from './PreferredWorkLocationsPicker';
import {
  CANDIDATE_TOGGLE_BTN,
  CANDIDATE_TOGGLE_BTN_ON,
  CANDIDATE_TOGGLE_BTN_OFF,
  CANDIDATE_WORK_PREFS_GRID,
  CORPORATE
} from '../constants/candidateFormStyles';
import { WORKING_MODES, CONTACT_CHANNELS } from '../utils/candidateFormValidation';

const CELL = `${CORPORATE.nestedCard} flex flex-col gap-2 min-w-0 h-full`;
const TOGGLE_WRAP = 'flex flex-wrap gap-2';

function FieldLabel({ children, required }) {
  return (
    <div className={CORPORATE.label}>
      {children}
      {required && <span className="text-red-600 normal-case tracking-normal"> *</span>}
    </div>
  );
}

/**
 * Work preferences: working mode | contact channels (badge-sized toggles), locations full width below.
 */
export default function WorkPreferencesFields({
  preferredWorkingModes = [],
  contactChannels = [],
  preferredWorkLocations = [],
  onToggleWorkingMode,
  onToggleContactChannel,
  onLocationsChange,
  locationCatalog = [],
  errors = {},
  workingModeLabel = 'Preferred working mode',
  contactLabel = 'Preferred contact channels',
  locationLabel = 'Preferred work location',
  workingModeRequired = false,
  contactRequired = false,
  locationRequired = false
}) {
  return (
    <div className={CANDIDATE_WORK_PREFS_GRID}>
      <div className={CELL}>
        <FieldLabel required={workingModeRequired}>{workingModeLabel}</FieldLabel>
        <div className={TOGGLE_WRAP} role="group" aria-label={workingModeLabel}>
          {WORKING_MODES.map(({ id, label }) => {
            const on = (preferredWorkingModes || []).includes(id);
            return (
              <button
                key={id}
                type="button"
                onClick={() => onToggleWorkingMode(id)}
                className={`${CANDIDATE_TOGGLE_BTN} ${
                  on ? CANDIDATE_TOGGLE_BTN_ON : CANDIDATE_TOGGLE_BTN_OFF
                }`}
              >
                {label}
              </button>
            );
          })}
        </div>
        {errors.preferredWorkingModes && (
          <p className="text-[10px] text-red-600">{errors.preferredWorkingModes}</p>
        )}
      </div>

      <div className={CELL}>
        <FieldLabel required={contactRequired}>{contactLabel}</FieldLabel>
        <div className={TOGGLE_WRAP} role="group" aria-label={contactLabel}>
          {CONTACT_CHANNELS.map(({ id, label }) => {
            const on = (contactChannels || []).includes(id);
            return (
              <button
                key={id}
                type="button"
                onClick={() => onToggleContactChannel(id)}
                className={`${CANDIDATE_TOGGLE_BTN} ${
                  on ? CANDIDATE_TOGGLE_BTN_ON : CANDIDATE_TOGGLE_BTN_OFF
                }`}
              >
                {label}
              </button>
            );
          })}
        </div>
        {errors.contactChannels && (
          <p className="text-[10px] text-red-600">{errors.contactChannels}</p>
        )}
      </div>

      <div className={`${CELL} sm:col-span-2 border-t border-[hsl(var(--ds-border))] sm:border-t-0 pt-3 sm:pt-0`}>
        <FieldLabel required={locationRequired}>{locationLabel}</FieldLabel>
        <PreferredWorkLocationsPicker
          selectedLocations={preferredWorkLocations}
          onChange={onLocationsChange}
          catalog={locationCatalog}
          error={errors.preferredWorkLocations}
          showCountBadge
        />
      </div>
    </div>
  );
}
